import Ember from 'ember';
export const isTestingMocks = {
  isTesting() {
    return Ember.testing;
  }
};
export function isTesting() {
  return isTestingMocks.isTesting();
}